import React from 'react';
import { ServicePageTemplate } from '../components/blocks/ServicePageTemplate';
import { getService } from '../data/services';

/**
 * PAGE: /start-your-journey/sound-infused-renewal
 * WORDPRESS: `service` CPT record, rendered by single-service.php
 */
export function SoundInfusedRenewal() {
  return <ServicePageTemplate service={getService('sound-infused-renewal')} data-id="element-613" data-mp="2gy1lk9obv3a4" />;
}